import { FieldGroup, FieldGroupProps } from '@idexx-laboratories/spot-react';
import classNames from 'classnames';
import React from 'react';
import { forwardRefWithAs } from '../../lib/polymorphic';
import './FieldGroupInCell.scss';

const FieldGroupInCell = forwardRefWithAs<'div', FieldGroupProps>(({ className, ...rest }, ref) => (
  <FieldGroup className={classNames(className, 'in-cell')} {...rest} ref={ref} />
));

export default FieldGroupInCell;
